module.exports = __webpack_public_path__ + "uia-add-to-library.16586acb1acf044a8efe8a7c13ed7aaf.svg";